"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const p=(...e)=>t=>e.reduce((i,o)=>o(i),t);exports.pipe=p;
